// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"245d021a","176":"81686080","504":"7138b7b3","892":"311709f2","924":"390573a2"}[chunkId] + ".chunk.js";
};